export const tags = (t) => [
    { label: t('commerce.tags.keywords'), id: 'keywords' },
    { label: t('commerce.tags.marketShare'), id: 'market_share' },
    { label: t('commerce.tags.contentGaps'), id: 'content_gaps' },
    { label: t('commerce.tags.urls'), id: 'urls' },
    { label: t('commerce.tags.opportunities'), id: 'opportunities' },
];
